import "../../ui/page-loader/PageLoader.scss";
import "./LoaderContent.scss";

export default function LoaderContent() {
    return (
        <div className="page-loader">
            <div className="page-loader__block">
                <div className="page-loader__block-title page-loader-search" />

                <div className="page-loader__block-item page-loader-search" />
                <div className="page-loader__block-item page-loader-search" />
                <div className="page-loader__block-item page-loader-search" />
                <div className="page-loader__block-item page-loader-search" />
                <div className="page-loader__block-item page-loader-search" />
            </div>

            {/* <div className="page-loader__block">
                <div className="page-loader__block-title page-loader-search" />

                <div className="page-loader__block-item page-loader-search" />
                <div className="page-loader__block-item page-loader-search" />
                <div className="page-loader__block-item page-loader-search" />
                <div className="page-loader__block-item page-loader-search" />
                <div className="page-loader__block-item page-loader-search" />
                <div className="page-loader__block-item page-loader-search" />
            </div> */}
        </div>
    );
}
